
<template>
  <div id="myheader" class="componentBackgroundColor">
    <div class="sw">
      <div class="homeCon" :class="sessionInfoGetter.isLogin == 'true' ? '' : 'homeBgFFF'">
        <div v-if="sessionInfoGetter.isLogin == 'true'" class="homeLeft">
          <div class="headerTitle">
            <p class="logo">
              <!-- <img :src="BASEURL+'static/logo.png'" height="36px" width="36px"> -->
              <img src="@/assets/images/logo.png" height="36px" width="36px">
            </p>
          </div>
          <div class="headerTitle">
            <div class="newSth"> <a v-for="item of APP_TITLELINKS" :key="item.url" :href="item.url+userInfo" target="_blank">{{ item.title }}</a></div>
          </div>
          <!-- <div class="headerTitle">
            <router-link tag="p" to="/centerHome">
              <span class="com">订货中心</span>
            </router-link>
          </div> -->
          <div class="headerTitle" @click="handleResetHomeIsSearch">
            <router-link tag="p" to="/mallIndex">
              <span class="com">订货商城</span>
            </router-link>
          </div>
          <div class="headerTitle">
            <router-link tag="p" to="/myAssetNew">
              <span class="com">资金管理</span>
            </router-link>
          </div>
          <!-- <div class="headerTitle">
            <router-link tag="p" to="/reportSystem">
              <span class="com">订单管理</span>
            </router-link>
          </div> -->
          <div class="headerTitle">
            <router-link tag="p" to="/orderManagement">
              <span class="com">订单管理</span>
            </router-link>
          </div>
          <div class="headerTitle">
            <router-link tag="p" to="/Notice">
              <span class="com">公告信息</span>
            </router-link>
          </div>
        </div>
        <div v-else class="homeLeft">
          <div class="headerTitle">
            <p class="logo">
              <img v-if="sessionInfoGetter.isLogin == 'true'" :src="BASEURL+'static/logo.png'" height="36px" width="36px">
              <img v-else :src="BASEURL+'static/logo.png'" height="40px" width="40px">
            </p>
          </div>
        </div>
        <div v-if="sessionInfoGetter.isLogin == 'true'" class="homeRight">
          <!-- <div class="headerTitle">
            <router-link tag="p" to="/reportSystem">
              <span class="com" style="color:#b0b8db;margin-right:4px;">订单管理</span>
            </router-link>
          </div> -->
          <!-- <div class="headerTitle">
            <router-link tag="p" to="/notice/noticelist">
              <span class="com">公告中心</span>
            </router-link>
          </div> -->
          <div class="headerTitle">
            <p>
              <span
                class="com"
                style="cursor:pointer;vertical-align: middle;"
              >客服热线：{{ APP_hotline }}</span>
            </p>
          </div>
          <div class="informationImg">
            <router-link tag="div" to="/information">
              <img src="../../../assets/images/informationSmall.png" alt="">
            </router-link>
          </div>
          <!-- <div class="rightTitle">
            <span class="com" @click="logout()">
              <img
                :src="BASEURL+'static/logout.png'"
                height="18px"
                width="18px"
                style="vertical-align: middle;margin-right:4px;"
              >
              <span class="outSty">退出登录</span>
            </span>
          </div> -->
        </div>
        <div v-else class="homeRight">
          <div class="rightTitle loginTitle">
            <router-link to="/login">
              <span>登录</span>
            </router-link>
          </div>
          <div class="rightTitle loginTitle">
            <el-button type="primary" size="mini" @click="() => { this.$router.push('/register/info') }">注册</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*global protocol http */
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Header',
  data() {
    return {
      APP_hotline: window.g.APP_hotline,
      APP_TITLELINKS: window.g.APP_TITLELINKS || [], // 跳转
      userInfo: '',
      path1: window.g.APP_clearing_house == 1 ? '/myAssetNew/mywithdrawNew' : '/myAssetNew/mywithdrawNewQd',
      currentPath: '',
      isResponse: false,
      color1: false,
      color2: false,
      color3: false,
      color4: false,
      isOpen: false,
      isSign: false,
      logoName: window.g.APP_TITLE_ALL,
      BASEURL: process.env.BASE_URL
    }
  },

  computed: {
    ...mapGetters(['sessionInfoGetter'])
  },
  watch: {
    sessionInfoGetter(val, old) {
      if (old?.isLogin !== 'true' && val?.isLogin == 'true') {
        this.initDDUrl()
      }
    }
  },
  mounted() {
    if (this.sessionInfoGetter.isLogin == 'true') {
      this.initDDUrl()
    }
    this.$store.commit('setTime_w', 0)
    if (localStorage.lang) {
      // localStorage.lang = localStorage.lang
    } else {
      localStorage.lang = 'cn'
    }
  },
  created() {
    this.changeTabBarItem()
  },
  methods: {
    ...mapMutations('pt', ['setHomeIsSearch']),
    // 重置首页搜索状态 - 非搜索
    handleResetHomeIsSearch() {
      this.setHomeIsSearch(1)
    },
    initDDUrl() {
      this.userInfo = '?userId=' + this.sessionInfoGetter.userId + '&firmId=' + this.sessionInfoGetter.firmId +
            '&sessionStr=' + this.sessionInfoGetter.sessionStr +
              '&tel=' + localStorage.getItem('myPhone') + '&equipmentFlag=' + localStorage.getItem('equipmentFlag_PC') || 4
      console.log(this.userInfo)
    },
    // 初始化按钮选中状态
    changeTabBarItem() {
      this.color1 = false
      this.color2 = false
      this.color3 = false
      // 更新调用方法刷新头视图展示
      var locationUrl = window.location.href
      if (
        locationUrl.indexOf('/myAssetNew') != -1 ||
        locationUrl.indexOf('/reportSystem') != -1 ||
        locationUrl.indexOf('/warehouseSys') != -1
      ) {
        if (locationUrl.indexOf('/myAssetNew') != -1) { // 资金管理
          this.color1 = true
        } else if (locationUrl.indexOf('/reportSystem') != -1) { // 报表系统
          this.color2 = true
        } else if (locationUrl.indexOf('/warehouseSys') != -1) { // 交收系统
          this.color3 = true
        }
      }
    },
    // 根据状态跳转
    toPage(path) {
      this.currentPath = path
      this.color1 = false
      this.color2 = false
      this.color3 = false
      if (path == '/myAssetNew/mywithdrawNew' || path == '/myAssetNew/mywithdrawNewQd') {
        this.color1 = true
      } else if (path == '/reportSystem') {
        this.color2 = true
      } else if (path == '/warehouseSys') {
        this.color3 = true
      }
      if (this.isSign) {
        this.$router.push(path)
      } else {
        this.$router.push('/noSign')
      }
    },
    logout() {
      protocol.param_logout.param.userid = this.sessionInfoGetter.userId
      http.postFront(protocol.param_logout).then(response => {
        const { code } = response.data
        if (code == '0') {
          sessionStorage.clear()
          this.$store.commit('setSessionInfo', '')
          this.$store.commit('marketStatusInNewTopline', '--')
          this.$router.push('/')
        }
      })
    }
  }
}
</script>
<style scoped  lang='scss'>

.homeCon {
  min-width: 1200px;
  padding-right: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(180deg, #1F243C 0%, #323855 100%);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
  .homeLeft {
    display: flex;
    align-items: center;
    div {
      display: inline-block;
      margin-right: 20px;
      position: relative;
      p {
        width: 80px;
        text-align: center;
        span {
           font-size: 15px;
          font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
          font-weight: 400;
          color: #B3B3B3;
        }
      }
    }
    .homeTitle {
      width: 70px;
      text-align: center;
    }
  }
  .homeRight {
    display: flex;
    align-items: center;
    .cell {
      width: 130px;
    }
    .com{
      font-size: 15px;
      font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
      font-weight: 400;
      color: #B5B5B5;
    }
    .avatar {
      position: relative;
      width: 20px;
      img {
        position: absolute;
        top: -15px;
      }
    }
    div {
      display: inline-block;
      position: relative;
      margin-right: 10px;
      span {
        font-size: 14px;
        color: #666666;
      }
      .outSty{
        display: inline-block;
        width: 70px;
        height: 26px;
        background: #0B51F7;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        font-family: PingFang HK-Regular, PingFang HK;
        font-weight: 400;
        color: #FFFFFF;
        text-align: center;
        line-height: 26px;
      }
      // span.imgText {
      //   vertical-align: middle;
      // }
    }

    .loginTitle {
      width: 50px;
      margin-right: 3px;
      /deep/ .el-button--primary span{
        color: #ffffff;
      }
    }
    .language-nav {
      text-align: right;

    }
    .downLoad{
      width:62px;
    }
    .enLoad{
      width:70px;
    }
  }
}
.homeBgFFF{
  background: #ffffff !important;
  // height: 40px;
  .com{
    color: #666666;
  }
}
.el-row {
  height: 48px;
  line-height: 48px;
  font-size: 14px;
}
.logo {
  min-width: 290px;
  position: relative;
  display:flex;
  justify-content: flex-start;
  align-items: center;
  img{
    margin-left: 34px;
    vertical-align: text-bottom;
  }
  div {
    padding-top:2px;
    margin-left:28px;
    font-size: 24px;
    font-family: PingFang HK-Regular, PingFang HK;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.8);
  }
}

.home {
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  height: 22px;
  width: 186px;
}

.login {
  text-align: right;
}
.register {
  text-align: center;
}
.com:hover {
  color: #2483ff;
  cursor: pointer;
}
.rightTitle a :hover {
  color: #2483ff;

}
.com {
  cursor: pointer;
  color: #b0b8db;
  position: relative;
  .noticeNote{
    position: absolute;
    right: -25px;
    top: -5px;
    background: red;
    color: white;
    padding: 0 5px;
    border-radius: 7px;
    font-size: 12px;
    line-height: 14px;
  }
}
.marketState{
  font-size: 15px;
  color: #b0b8db;
}
.router-link > div,
.router-link > span {
  display: inline-block;
  border-bottom: 3px solid transparent;
}

#telSpan {
  overflow: hidden;
}
.hotBox{
  position: absolute;
  height:17px;
  top: -5px;
  right: 16px;
}
.hotHeaderTitle{
  width: 120px;
  position: relative;
}
.headerTitle{
  height: 40px;
  display: flex;
  align-items: center;
  p{
    height: 40px;
    display: flex;
    align-items: center;
    position:relative;
    span{
      font-size: 20px;
      font-family: PingFang HK-Regular, PingFang HK;
      font-weight: 400;
      // color: rgba(255, 255, 255, 0.5);
      line-height: 28px;
    }
  }
}
.informationImg{
  height: 40px;
  width: 36px;
  margin-right: 0px !important;
  cursor: pointer;
  div{
    width: 36px;
    height: 36px;
    margin-right: 0px !important;
    img{
      margin-top: 2px;
      width: 36px;
      height: 36px;
    }
  }
}
// 弹出框修改
.Header_userTel {
  // background: url('../../../../../../../src/assets/images/usertelback.png') no-repeat;
  // background-size: cover;
  position: relative;
  width: 12.5rem;
  height: 1.8125rem;

  .userbackimg {
    position: absolute;
    width: 12.625rem;
    z-index: 1;
    left: -0.0625rem;
    // top: -0.6875rem;
    top: -0.9rem;
  }

  .telStr {
    color: #fff;
    position: absolute;
    z-index: 2;
    left: 1.25rem;
    top: -0.4rem;
  }

  .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
  .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
    font-weight: 600 !important;
  }
}
.newSth{
  white-space: nowrap;
  line-height:40px;
  margin-right:14px;
  a{
    font-size:15px;
    color: #b0b8db;
  }
}
</style>
<style>
  #myheader .router-link-active span,#myheader .router-link-active span:hover{
    font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
    font-weight: 500;
    color: #FFFFFF;
  }

  #myheader .router-link-active span::after,#myheader .router-link-active span:hover::after{
    content:'';
    position: absolute;
    bottom: -6px;
    left: -2px;
    width: 68px;
    height: 2px;
    background: linear-gradient(270deg, rgba(36,131,255,0) 0%, #598AFF 48%, rgba(36,131,255,0) 100%);
  }
  #myheader .fiveText .router-link-active span::after,#myheader .fiveText .router-link-active span:hover::after{
    width: 76px;
    left:0;
  }
  #myheader .headerTitle .com span:hover{
    color: #2483ff;
  }
 #myheader .noLogin .router-link-active span,#myheader .noLogin .router-link-active span:hover{
    color: #2483ff;
  }
  #myheader .loginTitle .router-link-active span,#myheader .loginTitle .router-link-active span:hover{
    color: #2483ff;
  }
  #myheader .loginTitle .router-link-active span::after, #myheader .loginTitle .router-link-active span:hover::after{
    width:40px;
    background:transparent;
    height: 0;
  }
</style>
